/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

import { NgModule } from '@angular/core';
import { DxAccordionModule } from 'devextreme-angular-rpk/ui/accordion';
import { DxActionSheetModule } from 'devextreme-angular-rpk/ui/action-sheet';
import { DxAutocompleteModule } from 'devextreme-angular-rpk/ui/autocomplete';
import { DxBarGaugeModule } from 'devextreme-angular-rpk/ui/bar-gauge';
import { DxBoxModule } from 'devextreme-angular-rpk/ui/box';
import { DxBulletModule } from 'devextreme-angular-rpk/ui/bullet';
import { DxButtonModule } from 'devextreme-angular-rpk/ui/button';
import { DxButtonGroupModule } from 'devextreme-angular-rpk/ui/button-group';
import { DxCalendarModule } from 'devextreme-angular-rpk/ui/calendar';
import { DxChartModule } from 'devextreme-angular-rpk/ui/chart';
import { DxCheckBoxModule } from 'devextreme-angular-rpk/ui/check-box';
import { DxCircularGaugeModule } from 'devextreme-angular-rpk/ui/circular-gauge';
import { DxColorBoxModule } from 'devextreme-angular-rpk/ui/color-box';
import { DxContextMenuModule } from 'devextreme-angular-rpk/ui/context-menu';
import { DxDataGridModule } from 'devextreme-angular-rpk/ui/data-grid';
import { DxDateBoxModule } from 'devextreme-angular-rpk/ui/date-box';
import { DxDeferRenderingModule } from 'devextreme-angular-rpk/ui/defer-rendering';
import { DxDiagramModule } from 'devextreme-angular-rpk/ui/diagram';
import { DxDraggableModule } from 'devextreme-angular-rpk/ui/draggable';
import { DxDrawerModule } from 'devextreme-angular-rpk/ui/drawer';
import { DxDropDownBoxModule } from 'devextreme-angular-rpk/ui/drop-down-box';
import { DxDropDownButtonModule } from 'devextreme-angular-rpk/ui/drop-down-button';
import { DxFileManagerModule } from 'devextreme-angular-rpk/ui/file-manager';
import { DxFileUploaderModule } from 'devextreme-angular-rpk/ui/file-uploader';
import { DxFilterBuilderModule } from 'devextreme-angular-rpk/ui/filter-builder';
import { DxFormModule } from 'devextreme-angular-rpk/ui/form';
import { DxFunnelModule } from 'devextreme-angular-rpk/ui/funnel';
import { DxGalleryModule } from 'devextreme-angular-rpk/ui/gallery';
import { DxGanttModule } from 'devextreme-angular-rpk/ui/gantt';
import { DxHtmlEditorModule } from 'devextreme-angular-rpk/ui/html-editor';
import { DxLinearGaugeModule } from 'devextreme-angular-rpk/ui/linear-gauge';
import { DxListModule } from 'devextreme-angular-rpk/ui/list';
import { DxLoadIndicatorModule } from 'devextreme-angular-rpk/ui/load-indicator';
import { DxLoadPanelModule } from 'devextreme-angular-rpk/ui/load-panel';
import { DxLookupModule } from 'devextreme-angular-rpk/ui/lookup';
import { DxMapModule } from 'devextreme-angular-rpk/ui/map';
import { DxMenuModule } from 'devextreme-angular-rpk/ui/menu';
import { DxMultiViewModule } from 'devextreme-angular-rpk/ui/multi-view';
import { DxNavBarModule } from 'devextreme-angular-rpk/ui/nav-bar';
import { DxNumberBoxModule } from 'devextreme-angular-rpk/ui/number-box';
import { DxPieChartModule } from 'devextreme-angular-rpk/ui/pie-chart';
import { DxPivotGridModule } from 'devextreme-angular-rpk/ui/pivot-grid';
import { DxPivotGridFieldChooserModule } from 'devextreme-angular-rpk/ui/pivot-grid-field-chooser';
import { DxPolarChartModule } from 'devextreme-angular-rpk/ui/polar-chart';
import { DxPopoverModule } from 'devextreme-angular-rpk/ui/popover';
import { DxPopupModule } from 'devextreme-angular-rpk/ui/popup';
import { DxProgressBarModule } from 'devextreme-angular-rpk/ui/progress-bar';
import { DxRadioGroupModule } from 'devextreme-angular-rpk/ui/radio-group';
import { DxRangeSelectorModule } from 'devextreme-angular-rpk/ui/range-selector';
import { DxRangeSliderModule } from 'devextreme-angular-rpk/ui/range-slider';
import { DxRecurrenceEditorModule } from 'devextreme-angular-rpk/ui/recurrence-editor';
import { DxResizableModule } from 'devextreme-angular-rpk/ui/resizable';
import { DxResponsiveBoxModule } from 'devextreme-angular-rpk/ui/responsive-box';
import { DxSankeyModule } from 'devextreme-angular-rpk/ui/sankey';
import { DxSchedulerModule } from 'devextreme-angular-rpk/ui/scheduler';
import { DxScrollViewModule } from 'devextreme-angular-rpk/ui/scroll-view';
import { DxSelectBoxModule } from 'devextreme-angular-rpk/ui/select-box';
import { DxSlideOutModule } from 'devextreme-angular-rpk/ui/slide-out';
import { DxSlideOutViewModule } from 'devextreme-angular-rpk/ui/slide-out-view';
import { DxSliderModule } from 'devextreme-angular-rpk/ui/slider';
import { DxSortableModule } from 'devextreme-angular-rpk/ui/sortable';
import { DxSparklineModule } from 'devextreme-angular-rpk/ui/sparkline';
import { DxSpeedDialActionModule } from 'devextreme-angular-rpk/ui/speed-dial-action';
import { DxSwitchModule } from 'devextreme-angular-rpk/ui/switch';
import { DxTabPanelModule } from 'devextreme-angular-rpk/ui/tab-panel';
import { DxTabsModule } from 'devextreme-angular-rpk/ui/tabs';
import { DxTagBoxModule } from 'devextreme-angular-rpk/ui/tag-box';
import { DxTextAreaModule } from 'devextreme-angular-rpk/ui/text-area';
import { DxTextBoxModule } from 'devextreme-angular-rpk/ui/text-box';
import { DxTileViewModule } from 'devextreme-angular-rpk/ui/tile-view';
import { DxToastModule } from 'devextreme-angular-rpk/ui/toast';
import { DxToolbarModule } from 'devextreme-angular-rpk/ui/toolbar';
import { DxTooltipModule } from 'devextreme-angular-rpk/ui/tooltip';
import { DxTreeListModule } from 'devextreme-angular-rpk/ui/tree-list';
import { DxTreeMapModule } from 'devextreme-angular-rpk/ui/tree-map';
import { DxTreeViewModule } from 'devextreme-angular-rpk/ui/tree-view';
import { DxValidationGroupModule } from 'devextreme-angular-rpk/ui/validation-group';
import { DxValidationSummaryModule } from 'devextreme-angular-rpk/ui/validation-summary';
import { DxValidatorModule } from 'devextreme-angular-rpk/ui/validator';
import { DxVectorMapModule } from 'devextreme-angular-rpk/ui/vector-map';
import { DxTemplateModule } from 'devextreme-angular-rpk/core';

@NgModule({
    imports: [
    DxAccordionModule,
    DxActionSheetModule,
    DxAutocompleteModule,
    DxBarGaugeModule,
    DxBoxModule,
    DxBulletModule,
    DxButtonModule,
    DxButtonGroupModule,
    DxCalendarModule,
    DxChartModule,
    DxCheckBoxModule,
    DxCircularGaugeModule,
    DxColorBoxModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDeferRenderingModule,
    DxDiagramModule,
    DxDraggableModule,
    DxDrawerModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxFileManagerModule,
    DxFileUploaderModule,
    DxFilterBuilderModule,
    DxFormModule,
    DxFunnelModule,
    DxGalleryModule,
    DxGanttModule,
    DxHtmlEditorModule,
    DxLinearGaugeModule,
    DxListModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    DxLookupModule,
    DxMapModule,
    DxMenuModule,
    DxMultiViewModule,
    DxNavBarModule,
    DxNumberBoxModule,
    DxPieChartModule,
    DxPivotGridModule,
    DxPivotGridFieldChooserModule,
    DxPolarChartModule,
    DxPopoverModule,
    DxPopupModule,
    DxProgressBarModule,
    DxRadioGroupModule,
    DxRangeSelectorModule,
    DxRangeSliderModule,
    DxRecurrenceEditorModule,
    DxResizableModule,
    DxResponsiveBoxModule,
    DxSankeyModule,
    DxSchedulerModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSlideOutModule,
    DxSlideOutViewModule,
    DxSliderModule,
    DxSortableModule,
    DxSparklineModule,
    DxSpeedDialActionModule,
    DxSwitchModule,
    DxTabPanelModule,
    DxTabsModule,
    DxTagBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxTileViewModule,
    DxToastModule,
    DxToolbarModule,
    DxTooltipModule,
    DxTreeListModule,
    DxTreeMapModule,
    DxTreeViewModule,
    DxValidationGroupModule,
    DxValidationSummaryModule,
    DxValidatorModule,
    DxVectorMapModule,
    DxTemplateModule
    ],
    exports: [
    DxAccordionModule,
    DxActionSheetModule,
    DxAutocompleteModule,
    DxBarGaugeModule,
    DxBoxModule,
    DxBulletModule,
    DxButtonModule,
    DxButtonGroupModule,
    DxCalendarModule,
    DxChartModule,
    DxCheckBoxModule,
    DxCircularGaugeModule,
    DxColorBoxModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDeferRenderingModule,
    DxDiagramModule,
    DxDraggableModule,
    DxDrawerModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxFileManagerModule,
    DxFileUploaderModule,
    DxFilterBuilderModule,
    DxFormModule,
    DxFunnelModule,
    DxGalleryModule,
    DxGanttModule,
    DxHtmlEditorModule,
    DxLinearGaugeModule,
    DxListModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    DxLookupModule,
    DxMapModule,
    DxMenuModule,
    DxMultiViewModule,
    DxNavBarModule,
    DxNumberBoxModule,
    DxPieChartModule,
    DxPivotGridModule,
    DxPivotGridFieldChooserModule,
    DxPolarChartModule,
    DxPopoverModule,
    DxPopupModule,
    DxProgressBarModule,
    DxRadioGroupModule,
    DxRangeSelectorModule,
    DxRangeSliderModule,
    DxRecurrenceEditorModule,
    DxResizableModule,
    DxResponsiveBoxModule,
    DxSankeyModule,
    DxSchedulerModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSlideOutModule,
    DxSlideOutViewModule,
    DxSliderModule,
    DxSortableModule,
    DxSparklineModule,
    DxSpeedDialActionModule,
    DxSwitchModule,
    DxTabPanelModule,
    DxTabsModule,
    DxTagBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxTileViewModule,
    DxToastModule,
    DxToolbarModule,
    DxTooltipModule,
    DxTreeListModule,
    DxTreeMapModule,
    DxTreeViewModule,
    DxValidationGroupModule,
    DxValidationSummaryModule,
    DxValidatorModule,
    DxVectorMapModule,
    DxTemplateModule
    ]
})
export class DevExtremeModule {}
